import { useEffect, useState } from "react";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { _colorText, _sizeHeading, _sizeText } from "../../core/core";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "../../shared/components/ui/carousel";
import "./ServiceBlock.css";

const steps = [
    {
        title: "Указать свой текст для отзыва ",
        desc: "Если хотите отзывы со своим текстом — просто укажите текст в личном кабинете. Ещё наш AI может помочь написать вам текст"
    },
    {
        title: "Добавить свое фото к отзыву ",
        desc: "Если необходимо прикрепить фото к отзыву — загрузите его в задание, исполнитель опубликует отзыв с фото"
    },
    {
        title: "Написать ключевые слова ",
        desc: "Вместо текста можете указать ключевые слова, например «Упомянуть мастера Марину», исполнитель учтет их в написании отзыва"
    },
    {
        title: "Выбрать дату выполнения ",
        desc: "Если не нужно публиковать сразу все отзывы — распределите публикацию по нужному вам графику. Автоматически распределяем 1 отзыв в день"
    },
    {
        title: "Посмотреть отчет и отправить на доработку",
        desc: "Можно посмотреть статус задания, имя исполнителя, скриншот выполненного задания, отправить на доработку, если что-то не так"
    }
];

const service_images = [
    {
        image: '/static/hm/images/service-block-1.png',
        title: 'Отчет о заказе, 1 отзыв = 1 задание ',
    },
    {
        image: '/static/hm/images/service-block-2.png',
        title: 'Выбор даты, фото, текста  ',
    },
    {
        image: '/static/hm/images/service-block-2.png',
        title: 'отправка на Доработку',
    },
]

export const ServiceBlock = () => {
    const [api, setApi] = useState<CarouselApi>();
    const [current, setCurrent] = useState(0);
    const [isHover, setIsHover] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        if (!api) return;

        api.on("select", () => {
            setIsTransitioning(true);
            setCurrent(api.selectedScrollSnap());

            // Сбрасываем состояние перехода через небольшую задержку
            setTimeout(() => {
                setIsTransitioning(false);
            }, 2000);
        });
    }, [api]);

    useEffect(() => {
        if (!api || isHover) return;

        const interval = setInterval(() => {
            api.scrollNext();
        }, 6000); // Автоплей каждые 6 секунд

        return () => clearInterval(interval);
    }, [api, isHover]);

    return (
        <div className="howwork-new">
            <div className="howwork-title">

                <Title type={_sizeHeading.h2_2}>
                    Возможности сервиса
                </Title>
            </div>
            <div className="howwork-block">
                {steps.map((step, idx) => (
                    <div className="howwork-card" key={idx}>
                        <Text size={_sizeText.mbold} color={_colorText.black}>&#x2022; </Text>
                        <div className="howwork-card-body">
                            <Text size={_sizeText.mbold} >{step.title}</Text>
                            <Text size={_sizeText.m} >{step.desc}</Text>
                        </div>
                    </div>
                ))}
                <Carousel
                    setApi={setApi}
                    opts={{
                        align: "start",
                        loop: true,
                    }}
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                    className="service-block-preview">
                    <CarouselPrevious className="service-block-carousel-btn" />
                    <CarouselContent >
                        {service_images.map((item, idx) => (
                            <CarouselItem key={idx} className="service-block-carousel-content">
                                <Title
                                    type={_sizeHeading.h3}
                                    color={_colorText.neutral}
                                >
                                    {item.title}
                                </Title>
                                <img
                                    src={item.image}
                                    alt={item.title + "hmrep.ru"}
                                    className={`service-block-img ${isTransitioning && idx !== current ? 'fade-out' : 'fade-in'}`}
                                />
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselNext className="service-block-carousel-btn" />
                </Carousel>
            </div>
        </div>
    );
};